import { isRouteErrorResponse, useRouteError } from 'react-router'
import { ContentError } from '@/components/ContentError'
import { TechnicalBreakPage } from './TechnicalBreakPage'

/**
 * Shown in place of a route that failed to load or render.
 */
export function RouterErrorBoundary() {
  const error = useRouteError()

  if (isRouteErrorResponse(error) && error.status === 404) {
    return (
      <ContentError
        title="Page not found"
        error="There is nothing at this address."
      />
    )
  }

  return <ErrorPageContainer error={error} />
}

interface ErrorPageContainerProps {
  error: unknown
}

/**
 * Shown in place of a page that crashed.
 */
export function ErrorPageContainer({ error }: ErrorPageContainerProps) {
  // The router catches the error, so it is not surfaced in the console otherwise.
  console.error(error)
  return (
    <ContentError
      title="Couldn't load this page"
      error={error}
      onRetry={reload}
    />
  )
}

/**
 * Shown instead of the app while the backends are down.
 */
export function TechnicalBreakPageContainer() {
  return <TechnicalBreakPage onRefresh={reload} />
}

function reload() {
  window.location.reload()
}
